import React from 'react'
import actions from 'redux/actions'

import Text from 'components/_new/typography/Text/Text'
import Box from 'components/_new/layout/Box/Box'

import FilterButton from './FilterButton/FilterButton'

import messages from './messages'
import s from './FilterButtons.scss'


const FilterButtons = () => (
  <Box className={s.section} mb="24">
    <FilterButton onClick={() => actions.view.smartSearchPage.openFiltersOverlay()}>
      <Text message={messages.filter} tag="span" />
    </FilterButton>
  </Box>
)

export default FilterButtons
